import { apiClient } from "./httpClient";
import { TermsAndConditions } from "./types";

const TERMS_BASE_URL = `${process.env.REACT_APP_API_URL}/terms-and-conditions`;

export const getLatestTermsAndConditions = async (): Promise<TermsAndConditions | null> => {
  try {
    const response = await apiClient.get(`${TERMS_BASE_URL}/latest`);
    return response.data as TermsAndConditions;
  } catch (error) {
    if ((error as { response?: { status?: number } })?.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const createTermsAndConditionsVersion = async (
  text: string,
): Promise<TermsAndConditions> => {
  const response = await apiClient.post(TERMS_BASE_URL, { text });
  return response.data as TermsAndConditions;
};

export const getMyTermsAndConditionsAcceptance = async (): Promise<boolean> => {
  const response = await apiClient.get(`${TERMS_BASE_URL}/acceptance/me`);
  return Boolean(response.data?.accepted);
};

export const acceptMyTermsAndConditions = async (): Promise<void> => {
  await apiClient.post(`${TERMS_BASE_URL}/acceptance/me`);
};
